export default function HowItWorks() {
  const steps = [
    {
      number: '01',
      title: 'Diagnóstico Inicial',
      description: 'Análise detalhada da estrutura tributária atual da sua empresa, identificando oportunidades de otimização fiscal.',
      icon: 'ri-search-line'
    },
    {
      number: '02',
      title: 'Estruturação da Solução',
      description: 'Desenvolvimento de estratégia personalizada utilizando direitos creditórios/ativo moeda, com total conformidade legal.',
      icon: 'ri-file-chart-line'
    },
    {
      number: '03',
      title: 'Implementação',
      description: 'Execução da operação com acompanhamento jurídico e contábil, garantindo segurança em todas as etapas do processo.',
      icon: 'ri-settings-3-line'
    },
    {
      number: '04',
      title: 'Monitoramento Contínuo',
      description: 'Acompanhamento permanente dos resultados por até 5 anos, e ajustes estratégicos para maximizar a eficiência tributária ao longo do tempo.',
      icon: 'ri-line-chart-line'
    }
  ];

  return (
    <section id="como-funciona" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-feenex-blue/5 rounded-full mb-4">
            <span className="text-sm font-semibold text-feenex-blue uppercase tracking-wider">Processo</span>
          </div>
          <h4 className="text-4xl lg:text-5xl font-bold text-feenex-blue mb-6">
            <a href="#como-funciona" className="hover:text-feenex-gold transition-colors">
              Como Funciona Nossa Metodologia
            </a>
          </h4>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Um processo estruturado e transparente, com acompanhamento em cada etapa para garantir resultados consistentes e seguros.
          </p>
        </div>

        {/* Steps Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              {/* Connector Line */}
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-16 left-full w-full h-0.5 bg-gradient-to-r from-feenex-gold to-feenex-gold/20 -translate-x-4"></div>
              )}
              
              <div className="relative bg-feenex-white rounded-lg p-6 border border-gray-100">
                {/* Number Badge */}
                <div className="absolute -top-4 -left-4 w-12 h-12 bg-feenex-gold rounded-full flex items-center justify-center shadow-lg">
                  <span className="text-feenex-blue font-bold text-lg">{step.number}</span>
                </div>

                {/* Icon */}
                <div className="w-12 h-12 bg-feenex-blue/5 rounded-lg flex items-center justify-center mb-4 mt-4">
                  <i className={`${step.icon} text-2xl text-feenex-blue`}></i>
                </div>

                {/* Content */}
                <h3 className="text-xl font-bold text-feenex-blue mb-3">
                  {step.title}
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center">
          <a 
            href="#contato"
            className="inline-flex items-center gap-2 px-8 py-4 bg-feenex-blue hover:bg-feenex-gold text-white hover:text-feenex-blue font-semibold rounded-md transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            Iniciar Diagnóstico Gratuito
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
